/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOAvailableTiersResponseDTO } from "../models/ApiResponseDTOAvailableTiersResponseDTO";
import type { ApiResponseDTODiscardUpgradeResponseDTO } from "../models/ApiResponseDTODiscardUpgradeResponseDTO";
import type { ApiResponseDTOFinishUpgradeTierResponseDTO } from "../models/ApiResponseDTOFinishUpgradeTierResponseDTO";
import type { ApiResponseDTOStartUpgradeTierResponseDTO } from "../models/ApiResponseDTOStartUpgradeTierResponseDTO";
import type { ApiResponseDTOTierDetailDTO } from "../models/ApiResponseDTOTierDetailDTO";
import type { ApiResponseDTOTierUpgradeStatusResponseDTO } from "../models/ApiResponseDTOTierUpgradeStatusResponseDTO";
import type { ApiResponseDTOUpgradeTierZenithAccountResponseDTO } from "../models/ApiResponseDTOUpgradeTierZenithAccountResponseDTO";
import type { StartUpgradeTierRequestDTO } from "../models/StartUpgradeTierRequestDTO";
import type { UpgradeTierZenithAccountRequestDTO } from "../models/UpgradeTierZenithAccountRequestDTO";
import type { WalletInfoRequestDTO } from "../models/WalletInfoRequestDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class TierApiService {
  /**
   * Get available tiers
   * Get the list of available tiers
   * @returns ApiResponseDTOAvailableTiersResponseDTO OK
   * @throws ApiError
   */
  public static getAvailableTiers(): CancelablePromise<ApiResponseDTOAvailableTiersResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tier",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Discard upgrade tier
   * Discards the upgrade tier
   * @returns ApiResponseDTODiscardUpgradeResponseDTO OK
   * @throws ApiError
   */
  public static discardUpgradeTier(): CancelablePromise<ApiResponseDTODiscardUpgradeResponseDTO> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/tier/discard-upgrade",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Finish the Merchant upgrade tier
   * Returns detailed status information for each step in the asynchronous upgrade flow
   * @returns ApiResponseDTOFinishUpgradeTierResponseDTO OK
   * @throws ApiError
   */
  public static finishUpgradeTier(): CancelablePromise<ApiResponseDTOFinishUpgradeTierResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tier/finish-upgrade",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Start the Merchant upgrade tier
   * Start the Merchant upgrade tier
   * @param requestBody
   * @returns ApiResponseDTOStartUpgradeTierResponseDTO OK
   * @throws ApiError
   */
  public static startUpgradeTier(
    requestBody: StartUpgradeTierRequestDTO
  ): CancelablePromise<ApiResponseDTOStartUpgradeTierResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tier/start-upgrade",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Upgrade tier with Zenith account
   * Upgrades account with Zenith account
   * @param requestBody
   * @returns ApiResponseDTOUpgradeTierZenithAccountResponseDTO OK
   * @throws ApiError
   */
  public static upgradeTierZenithAccount(
    requestBody: UpgradeTierZenithAccountRequestDTO
  ): CancelablePromise<ApiResponseDTOUpgradeTierZenithAccountResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tier/upgrade/zenith-account",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get upgrade status
   * Get the status of an ongoing upgrade
   * @param processId
   * @returns ApiResponseDTOTierUpgradeStatusResponseDTO OK
   * @throws ApiError
   */
  public static getUpgradeStatus(
    processId: string
  ): CancelablePromise<ApiResponseDTOTierUpgradeStatusResponseDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/tier/upgrade/{processId}/status",
      path: {
        processId: processId,
      },
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * Get wallet tier
   * API used to retrieve the tier of a wallet
   * @param requestBody
   * @returns ApiResponseDTOTierDetailDTO OK
   * @throws ApiError
   */
  public static getWalletTier(
    requestBody: WalletInfoRequestDTO
  ): CancelablePromise<ApiResponseDTOTierDetailDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/tier/wallet",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        404: `Not Found`,
        422: `Unprocessable Entity`,
        501: `Not Implemented`,
      },
    });
  }
}
